import { render, staticRenderFns } from "./country-header.vue?vue&type=template&id=6bbd6357&scoped=true"
import script from "./country-header.vue?vue&type=script&lang=js"
export * from "./country-header.vue?vue&type=script&lang=js"
import style0 from "./country-header.vue?vue&type=style&index=0&id=6bbd6357&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd6357",
  null
  
)

export default component.exports